import { render, staticRenderFns } from "./BsData.vue?vue&type=template&id=3734164a&scoped=true"
import script from "./BsData.vue?vue&type=script&lang=js"
export * from "./BsData.vue?vue&type=script&lang=js"
import style0 from "./BsData.vue?vue&type=style&index=0&id=3734164a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3734164a",
  null
  
)

export default component.exports